module.exports = __webpack_public_path__ + "img/st-louis.ceb46cf9.svg";